// extracted by mini-css-extract-plugin
export var dividerLine = "_6e-3";
export var itemImage = "_6e-9";
export var lightDivider = "_6e-4";
export var modalContent = "_6e-5";
export var modalContentCompact = "_6e-6";
export var productCard = "_6e-a";
export var productImage = "_6e-b";
export var productImageCompact = "_6e-7";
export var productImagePlaceholder = "_6e-c";
export var productImagePlaceholderCompact = "_6e-8";
export var progressBarBackground = "_6e-1";
export var progressBarContainer = "_6e-0";
export var progressBarFill = "_6e-2";